const validator = require("./validator");
const extractor = require("./extractor");

/**
 * @module validator
 *
 * @description
 *
 * Eligibility validator
 */
module.exports = validator;

/**
 * @alias module:extractor
 *
 * @description
 *
 * Get printable eligibility criteria.
 */
module.exports.extractor = extractor;
